import React, { useEffect, useState } from "react"
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap"
import { withTranslation } from "react-i18next"
import { Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

import megamenuImg from "../../../assets/images/megamenu-img.png"

//i18n
import i18n from "../../../i18n"
import languages from "common/languages"

import { useDispatch } from "react-redux"

import { SetCampusVirtualIdCampus } from "../../../store/campusvirtual/actions"

import {
  useCampusVirtualNombreCampusSeleccionado,
  useCampusVirtualListaCampusActivosDisplayconPermiso,
} from "../../../store/campusvirtual/selectors"

const CampiMegaMenu = props => {
  const [megaMenu, setmegaMenu] = useState(false)

  const lista_Campus = useCampusVirtualListaCampusActivosDisplayconPermiso()
  let numero_separador = lista_Campus.length / 4

  //console.log("numero_separador: ", numero_separador)
  if (lista_Campus.length < 5) {
    numero_separador = 1
  }

  const dispatch = useDispatch()

  return (
    <React.Fragment>
      <Dropdown
        className="dropdown-mega d-none d-lg-block ms-2"
        isOpen={megaMenu}
        toggle={() => {
          setmegaMenu(!megaMenu)
        }}
      >
        <DropdownToggle className="btn header-item " caret tag="button">
          {" "}
          {props.t(useCampusVirtualNombreCampusSeleccionado())}{" "}
          <i className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-megamenu">
          <Row>
            <Col sm={8}>
              <Row>
                <Col md={4}>
                  <h5 className="font-size-14 mt-0">{props.t("Campi")}</h5>
                  <ul className="list-unstyled megamenu-list">
                    {lista_Campus.map((campus, index) => {
                      if (index < numero_separador) {
                        return (
                          <li key={index}>
                            <Link
                              to="#"
                              onClick={() => {
                                dispatch(
                                  SetCampusVirtualIdCampus(campus.id_Campus)
                                )
                                setmegaMenu(false)
                                localStorage.setItem(
                                  "idCampusSelected",
                                  campus.id_Campus
                                )
                              }}
                            >
                              {props.t(campus.Nombre_Campus)}
                            </Link>
                          </li>
                        )
                      }
                    })}
                  </ul>
                </Col>

                <Col md={4}>
                  <h5 className="font-size-14 mt-0">{props.t("")}</h5>
                  <ul className="list-unstyled megamenu-list">
                    {lista_Campus.map((campus, indice2) => {
                      if (
                        (indice2 > numero_separador - 1) &
                        (indice2 < numero_separador * 2)
                      ) {
                        return (
                          <li key={indice2}>
                            <Link
                              to="#"
                              onClick={() => {
                                dispatch(
                                  SetCampusVirtualIdCampus(campus.id_Campus)
                                )
                                setmegaMenu(false)
                                localStorage.setItem(
                                  "idCampusSelected",
                                  campus.id_Campus
                                )
                              }}
                            >
                              {props.t(campus.Nombre_Campus)}
                            </Link>
                          </li>
                        )
                      }
                    })}
                  </ul>
                </Col>

                <Col md={4}>
                  <h5 className="font-size-14 mt-0"> {props.t(" ")} </h5>
                  <ul className="list-unstyled megamenu-list">
                    {lista_Campus.map((campus, index) => {
                      if (
                        (index > numero_separador * 2 - 1) &
                        (index < numero_separador * 3)
                      ) {
                        return (
                          <li key={index}>
                            <Link
                              to="#"
                              onClick={() => {
                                dispatch(
                                  SetCampusVirtualIdCampus(campus.id_Campus)
                                )
                                setmegaMenu(false)
                                localStorage.setItem(
                                  "idCampusSelected",
                                  campus.id_Campus
                                )
                              }}
                            >
                              {props.t(campus.Nombre_Campus)}
                            </Link>
                          </li>
                        )
                      }
                    })}
                  </ul>
                </Col>
              </Row>
            </Col>
            <Col sm={4}>
              <Row>
                <Col sm={6}>
                  <h5 className="font-size-14 mt-0">{props.t("")}</h5>
                  <ul className="list-unstyled megamenu-list">
                    {lista_Campus.map((campus, index) => {
                      if (
                        (index > numero_separador * 3 - 1) &
                        (index < numero_separador * 5)
                      ) {
                        return (
                          <li key={index}>
                            <Link
                              to="#"
                              onClick={() => {
                                dispatch(
                                  SetCampusVirtualIdCampus(campus.id_Campus)
                                )
                                setmegaMenu(false)
                                localStorage.setItem(
                                  "idCampusSelected",
                                  campus.id_Campus
                                )
                              }}
                            >
                              {props.t(campus.Nombre_Campus)}
                            </Link>
                          </li>
                        )
                      }
                    })}
                  </ul>
                </Col>

                <Col sm={5}>
                  <div>
                    <img
                      src={megamenuImg}
                      alt=""
                      className="img-fluid mx-auto d-block"
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(CampiMegaMenu)
